import { useSDKErrorParser } from "module/notification/hook/useSDKErrorParser"

import { Alert, AlertIcon, AlertProps } from "@chakra-ui/react"

interface ErrorAlertProps extends AlertProps {
    error: Error
}

function ErrorAlert({ error }: ErrorAlertProps) {
    const { parseSdkErrorMessage } = useSDKErrorParser()
    const { isSDKError, message } = parseSdkErrorMessage(error)

    return (
        <Alert status="error" fontSize={"xs"} mb={3}>
            <AlertIcon boxSize="16px" />
            {isSDKError ? message : error.message}
        </Alert>
    )
}

export default ErrorAlert
